import {
  ChevronLeft,
  Image,
  ListChecks,
  Pencil,
  Share2,
  Type,
  Plus,
  X,
  StickyNote,
  Search,
  Undo2,
  Trash2,
  Ellipsis,
} from "lucide-react";
const icons = {
  back: ChevronLeft,
  image: Image,
  check: ListChecks,
  edit: Pencil,
  share: Share2,
  text: Type,
  plus: Plus,
  close: X,
  note: StickyNote,
  search: Search,
  undo: Undo2,
  delete: Trash2,
  more: Ellipsis,
};
export function Icon({ name }: { name: keyof typeof icons }) {
  const Glyph = icons[name];
  return <Glyph size={20} strokeWidth={1.75} aria-hidden="true" />;
}
